/* unplugin-vue-components disabled */import script from "./CartList.vue?vue&type=script&setup=true&lang=js"
export * from "./CartList.vue?vue&type=script&setup=true&lang=js"

import "./CartList.vue?vue&type=style&index=0&id=3913cc1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3913cc1e"]])

export default __exports__